import api from '@/services/Api';

class Impersonation {
  static consume(ticket) {
    return api.post('/impersonation/consume', { ticket });
  }

  static refresh(refreshToken) {
    return api.post('/impersonation/refresh', { refreshToken });
  }
}

export default Impersonation;
